<p class="mat-body-2">
  <ng-content></ng-content>
</p>
